import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { authRouteAnimation } from '../auth-route.animations';

@Component({
  selector: 'app-auth-shell',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './auth-shell.component.html',
  styleUrl: './auth-shell.component.scss',
  animations: [authRouteAnimation],
})
export class AuthShellComponent {
  readonly prefersReducedMotion = signal(false);

  constructor() {
    if (typeof matchMedia !== 'undefined') {
      this.prefersReducedMotion.set(
        matchMedia('(prefers-reduced-motion: reduce)').matches,
      );
    }
  }

  prepareRoute(outlet: RouterOutlet): string {
    return (outlet?.activatedRouteData?.['authAnim'] as string) ?? 'auth';
  }
}
